
import { defineComponent } from 'vue'
import { iCategory } from './CategoriesManagement'
import { FilterOperator } from 'primevue/api'
import { filterDefault } from '../../../helpers/commons/filterHelper'
import { AxiosResponse } from 'axios'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import descriptor from './CategoriesManagementDescriptor.json'
import CategoriesManagementDialog from './CategoriesManagementDialog.vue'
import KnFabButton from '../../../components/UI/KnFabButton.vue'

export default defineComponent({
    name: 'categories-management',
    components: { Column, DataTable, CategoriesManagementDialog, KnFabButton },
    setup() {},
    data() {
        return {
            descriptor: descriptor,
            categories: [] as iCategory[],
            selectedCategory: null as iCategory | null,
            filters: {
                global: [filterDefault],
                code: { operator: FilterOperator.AND, constraints: [filterDefault] },
                name: { operator: FilterOperator.AND, constraints: [filterDefault] },
                occurrences: { operator: FilterOperator.AND, constraints: [filterDefault] },
                type: { operator: FilterOperator.AND, constraints: [filterDefault] }
            } as Object,
            formVisible: false,
            loading: false
        }
    },
    created() {
        this.loadCategories()
    },
    methods: {
        async loadCategories() {
            this.loading = true
            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '3.0/category/categories')
                .then((response: AxiosResponse<any>) => (this.categories = response.data))
                .finally(() => (this.loading = false))
        },
        deleteCategoryConfirm(category: iCategory) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteConfirmTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.deleteCategory(category)
            })
        },
        async deleteCategory(category: iCategory) {
            const dataToDelete = { code: category.code, id: category.id, name: category.name, type: category.type } as any

            await this.$http.delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '3.0/category', { data: dataToDelete }).then(() => {
                this.$store.commit('setInfo', {
                    title: this.$t('common.toast.deleteTitle'),
                    msg: this.$t('common.toast.deleteSuccess')
                })
                this.loadCategories()
            })
        },
        showForm(event: any) {
            if (event) {
                this.selectedCategory = event.data
            }
            this.formVisible = true
        },
        closeForm() {
            this.selectedCategory = null
            this.formVisible = false
        },
        reloadCategories() {
            this.formVisible = false
            this.loadCategories()
        },
        getBadgeColor(value) {
            if (value > 0) return 'background: #3B82F6'
            else return 'background: #cccccc'
        }
    }
})
